import React, { useState } from 'react'
import { NavLink } from "react-router-dom";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null)

  const toggleDropdown = (key) => {
    setOpenDropdown(openDropdown === key ? null : key)
  }

  const closeAllMenus = () => {
    setOpenDropdown(null)
    setMenuOpen(false)
  }

  return (
    <nav className={styles.navbar}>
      <NavLink to="/" className={styles.brand}>
        <img src="/LOGO.svg" alt="ASJF logo" className={styles.logo} />
      </NavLink>

      <button
        className={styles.menuButton}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-expanded={menuOpen}
        aria-controls="navbar-links"
        aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
      >
        <span />
        <span />
        <span />
      </button>

      <ul id="navbar-links" className={`${styles.links_list} ${menuOpen ? styles.open : ''}`}>
        <li className={`${styles.dropdown} ${openDropdown === 'historia' ? styles.openDropdown : ''}`}>
          <div className={styles.dropdownHeader}>
            <NavLink to="/historia" onClick={closeAllMenus} className={({ isActive }) => (isActive ? styles.active : styles.link)}>
              História
            </NavLink>
            <button
              type="button"
              className={styles.dropdownToggle}
              onClick={() => toggleDropdown('historia')}
              aria-expanded={openDropdown === 'historia'}
              aria-controls="historia-menu"
              aria-label="Abrir submenu História"
            >
              <span />
            </button>
          </div>
          <ul id="historia-menu" className={styles.dropdownMenu}>
            <li>
              <NavLink to="/presidencia" onClick={closeAllMenus} className={({ isActive }) => (isActive ? styles.active : styles.link)}>
                Presidentes Anteriores
              </NavLink>
            </li>
          </ul>
        </li>

        <li className={`${styles.dropdown} ${openDropdown === 'diretoria' ? styles.openDropdown : ''}`}>
          <div className={styles.dropdownHeader}>
            <NavLink to="/diretoria" className={({ isActive }) => (isActive ? styles.active : styles.link)}>
              Diretoria
            </NavLink>
            <button
              type="button"
              className={styles.dropdownToggle}
              onClick={() => toggleDropdown('diretoria')}
              aria-expanded={openDropdown === 'diretoria'}
              aria-controls="diretoria-menu"
              aria-label="Abrir submenu Diretoria"
            >
              <span />
            </button>
          </div>
          <ul id="diretoria-menu" className={styles.dropdownMenu}>
            <li>
              <NavLink to="/estatuto" onClick={closeAllMenus} className={({ isActive }) => (isActive ? styles.active : styles.link)}>
                Estatuto
              </NavLink>
            </li>
            <li>
              <NavLink to="/ata" onClick={closeAllMenus} className={({ isActive }) => (isActive ? styles.active : styles.link)}>
                Atas
              </NavLink>
            </li>
          </ul>
        </li>

        <li>
          <NavLink to="/midias" onClick={closeAllMenus} className={({ isActive }) => (isActive ? styles.active : styles.link)}>
            Mídias
          </NavLink>
        </li>
        <li>
          <NavLink to="/contato" onClick={closeAllMenus} className={({ isActive }) => (isActive ? styles.active : styles.link)}>
            Contato
          </NavLink>
        </li>
        <li>
          <NavLink to="/sistemasjf" onClick={closeAllMenus} className={({ isActive }) => (isActive ? styles.active : styles.link)}>
            Sistema ASJF
          </NavLink>
        </li>
      </ul>
    </nav>
  )
}

export default Navbar
